import { format } from 'date-fns';

export const mapOrderListToCsvExport = (orders: Array<any>) => {
    if (orders.length === 0) {
        return [];
    }

    return orders.map((order) => {
        return {
            'Invoice Number': order.invoice_number,
            Date: format(order.created_at, 'dd-MM-yyyy'),
            Time: format(order.created_at, 'HH:mm a'),
            'Customer Name': order.customer?.name || 'Walk-In Customer',
            'Order Type': order.order_type,
            'Order Status': order.payment?.status || 'N/A',
            'Total Price': order.payment?.total_price || 0,
            'Total Paid': order.payment?.total_paid || 0,
            'Total Due': order.payment?.total_due || 0,
        };
    });
};
